<template>
<div class="data-table">
    <el-table
        :data="tableData"
        header-row-class-name="data-table-header"
        style="width: 100%"
        row-key="id"
        :tree-props="treeprops">
        <el-table-column
            v-for="(colItem,i) in colums"
            :key="i"
            :prop="colItem.prop"
            :label="colItem.label"
            :width="colItem.width?colItem.width:'auto'"
        >
        <template slot-scope="scope">
          <cell v-if="colItem.render" :render="colItem.render" :row="scope.row" :index="scope.$index" :column="colItem"></cell>
          <span v-else>{{scope.row[colItem.prop]}}</span>
        </template>
      </el-table-column>
       <!-- 操作列插槽 -->
      <slot name="operation"></slot>
  </el-table>
</div>
</template>
<script>
import cell from '../dataTable/expand';
  export default {
    components: {cell},
    props:{
        // 表格属性
        tableData: {
            type: Array,
            default: () => { return []}
        },
        colums: {
            type: Array,
            default: () => { return []}
        },
        treeprops:{
            type:Object,
            default:() => { return {children: 'children', hasChildren:'hasChildren'}}
        },
    },
    data() {
      return {
       
      }
    },
    methods: {
      
    },
  }
</script>
<style lang="scss">
$highColor:#108cee;
.data-table{
  position: relative;
  &-header{
    height: 48px;
    background-color: #f3f7ff!important;
    th{
      background-color: #f3f7ff!important;
      color: #262626;
      font-family: "Ping Fang";
    }
  }
  &-row{
    height: 40px;
    box-sizing: border-box;
  }
  // render项
  .cell-row{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .cell-icon{
    vertical-align: middle;
    padding-left: 5px;
  }
  .cell-img{
    height: 35px;
    margin-right: 5px;
  }
  .cell-shop .img{
    display: inline-block;
    background-size: 15px 15px;
    margin: 0 0 0 5px;
    vertical-align: middle;
  }
  .cell-span{
    &.link{
      color: #409eff;
      cursor: pointer;
    }
  }
  // 收缩展开图标
  .el-table__expand-icon{
    display: inline-block;
    width: 17px!important;
    height: 17px!important;
    line-height: 12px!important;
    text-align: center;
    background: #fff;
    border: 1px solid #e8e8e8;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &>.el-icon-arrow-right{
      display: none;
    }
    &:after {
      content: "+";
    }
    &.el-table__expand-icon--expanded{
      transform: rotate(0);
      &:after{
        content: "-";
      }
    }
  }
}
</style>
